





























































import { Vue, Component } from 'vue-property-decorator';
import TestimonialCard from './TestimonialCard.vue';
import HeaderSection from './HeaderSection.vue';

interface Element {
    isSelected: boolean,
    country: string,
    translateX: number
}

@Component({
    components: {
        TestimonialCard,
        HeaderSection
    }
})
export default class TestimonialSection extends Vue {
    private elements: Array<Element>
    private selectedIndex: number
    private showingElements: Array<Element>;
    private window: number = 0;
    
    constructor() {
        super();
        this.elements = [
            { isSelected: false, country: 'USA', translateX: 0 },
            { isSelected: true, country: 'France', translateX: 0 },
            { isSelected: false, country: 'UK', translateX: 0 }
        ];
        this.showingElements = this.elements.slice();
        this.selectedIndex = 1;

    }

    mounted() {
        let index: number = this.showingElements.findIndex((el) => el.isSelected);
        let elem = document.getElementsByClassName('testimonial-card');
        var elemRect = elem[0].getBoundingClientRect();
        for (let i = 0; i < this.showingElements.length; i++) {
            const element = this.showingElements[i];
            if (i < index) {
                this.showingElements[i].translateX = -(index - i) * (elemRect.width + 30); 
            }
            else if(i > index) {
                this.showingElements[i].translateX = -(index - i) * (elemRect.width + 30); 
            }
        }

        setInterval(() => {
            if (this.selectedIndex !== 2) {
                // @ts-ignore
                this.selectThis(null, this.selectedIndex + 1);

            } else {

                // @ts-ignore
                this.selectThis(null, 0);
            }
        }, 5000);
    }

    startedMove: boolean = false;
    startPos: number = 0;
    mouseDown(e: MouseEvent) {
        this.startedMove = true;
        this.startPos = e.offsetX;
    }

    mouseMove(e: MouseEvent) {
        if (e.buttons === 1 && this.startedMove) {
            if (e.movementX > 0 && this.selectedIndex !== 0 && Math.abs(this.startPos - e.offsetX) > 100){
                this.selectThis(e, this.selectedIndex - 1);
                this.startedMove = false;
            } else if (e.movementX < 0 && this.selectedIndex !== 2) {
                this.selectThis(e, this.selectedIndex + 1);
                this.startedMove = false;
            }
        }
    }

    selectThis(e: MouseEvent, index: number) : void {
        if (index === this.selectedIndex)
            return;
        let elem = document.getElementsByClassName('testimonial-card');
        var elemRect = elem[0].getBoundingClientRect();
        for (let i = 0; i < index; i++) {
            this.showingElements[i].translateX = (elemRect.width + 30) * -(index - i);
        }
        for (let i = index; i < this.showingElements.length; i++) {
            this.showingElements[i].translateX = (elemRect.width + 30) * -(index - i);
        }

        this.selectedIndex = index;
        this.showingElements[index].translateX = 0;

    }
}
